// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__22FTV","header":"styles_header__3GYHU","table":"styles_table__1rHP8"};